import React, { ReactElement } from 'react';
import classnames from 'classnames';
import styles from './activityTab.module.scss';
import { ActivityAssociation, EActivityType } from 'v2/models';
import ActivityItem from './ActivityItems/ActivityItem';
import ActivityItemActions from './ActivityItemActions';
import ActivityItemAssociations from 'v2/common/DRM/ActivityTab/ActivityItemAssociations';
import {
  IUseGetActivityProps,
  useGetActivities,
} from 'v2/hooks/useGetActivities';
import InfiniteScrollV2 from 'v2/common/InfiniteScrollV2/InfiniteScrollV2';
import EmptyPlaceholder from '../ListPages/EmptyPlaceholder';

export interface ActivityListProps {
  listDescriptor: IUseGetActivityProps;
  defaultAssociations: ActivityAssociation[];
  children?: ReactElement;
}

const ActivityTabList = ({
  listDescriptor,
  defaultAssociations,
  children,
}: ActivityListProps) => {
  const { data, fetchNextPage, hasNextPage, isFetching, refetch } =
    useGetActivities(listDescriptor);

  if (!data) {
    return null;
  }

  return (
    <div className={classnames(styles.activityListContainer)}>
      {data.pages.map((page) => (
        <React.Fragment key={page.next}>
          {page.count > 0 ? (
            <>
              {page.results.map((activity) => {
                return (
                  <ActivityItem
                    key={activity.id}
                    activity={activity}
                    showsActions={activity.type !== EActivityType.link_created}
                    actionsComponent={
                      <ActivityItemActions
                        defaultAssociations={defaultAssociations}
                        activity={activity}
                        refetch={refetch}
                      />
                    }
                    showsAssociations={
                      activity.type !== EActivityType.link_created
                    }
                    associationsComponent={
                      <ActivityItemAssociations
                        disabled={isFetching}
                        activity={activity}
                        refetch={refetch}
                        defaultAssociations={defaultAssociations}
                      />
                    }
                  />
                );
              })}
            </>
          ) : listDescriptor.filterSearchText ? (
            <EmptyPlaceholder
              message={`Try adjusting your search or filter to find what you’re looking for.`}
            />
          ) : (
            children
          )}
        </React.Fragment>
      ))}
      <InfiniteScrollV2
        fetchNextPage={async () => {
          await fetchNextPage();
        }}
        hasNextPage={hasNextPage}
        rootMargin={'0px'}
      />
    </div>
  );
};

export default ActivityTabList;
